import { useEffect, useState, CSSProperties } from 'react';
import {
  requestBranchReviews,
  type BranchReviewPlace,
} from '@lib/requests/branchReviews';

type BranchReviewsProps = {
  logo: string;
  placeId: string;
};

const BranchReviews = ({ logo, placeId }: BranchReviewsProps) => {
  const [place, setPlace] = useState<BranchReviewPlace | null>(null);

  const starRating = (rating: number) => {
    const fillStyle = {
      '--rating-fill': `${(rating / 5) * 100}%`,
    } as CSSProperties;

    return (
      <div className="google__stars">
        <span className="ch-reader">{rating} out of 5 stars</span>
        <div className="google__stars--fill" style={fillStyle}></div>
      </div>
    );
  };

  useEffect(() => {
    const initialisePlace = async (id: string) => {
      const placeDetails = await requestBranchReviews(id);
      setPlace(placeDetails);
    };

    if (placeId) initialisePlace(placeId);
  }, [placeId]);

  if (!place)
    return (
      <div className="ch-width--12 ch-skeleton google__ratings--skeleton">
        <span className="google-sans-flex ch-reader">Loading Google Maps</span>
      </div>
    );

  return (
    <div className="google-sans-flex">
      <div className="ch-card__content">
        <div className="ch-display--flex ch-flex-direction--column md:ch-flex-direction--row ch-justify-content--between ch-justify-content--center ch-align-items--center ch-fs--3 md:ch-fs--4 ch-text--center ch-color--grey-6">
          <div className="ch-display--flex ch-flex-direction--column md:ch-flex-direction--row ch-justify-content--between ch-justify-content--center ch-align-items--center md:ch-gap--2">
            <img
              alt="Google logo"
              className="ch-ma--2 ch-mh--auto md:ch-ma--0"
              height={50}
              loading="lazy"
              src={logo}
              width={50}
            />
            <h3 className="ch-text--center ch-color--grey-6 ch-mb--4 md:ch-ma--0">
              Google Maps
            </h3>
          </div>
          <div className="ch-display--flex ch-flex-direction--column md:ch-flex-direction--row ch-justify-content--between ch-justify-content--center ch-align-items--center md:ch-gap--2">
            <p className="ch-fw--500 ch-mb--2 md:ch-ma--0 google__ratings">
              <span className="ch-fw--800 ch-fs--6">{place.rating}</span> stars
            </p>
            <div className="md:ch-br--2 ch-bc--grey-3 md:ch-pr--2">
              {starRating(place.rating)}
            </div>
            <hr className="ch-mv--1 ch-colour--grey-3 ch-ba--1 ch-bc--grey-3 ch-width--1 ch-mh--auto md:ch-display--none" />
            <p className="ch-fw--500 ch-mb--4 md:ch-ma--0">
              Based on{' '}
              <span className="ch-fw--600">{place.userRatingCount}</span>{' '}
              reviews
            </p>
          </div>
          <a
            className="ch-btn ch-btn--sm ch-mb--2 md:ch-ma--0 ch-mh--auto"
            href={place.googleMapsReviewsUri}
            rel="noreferrer"
            target="_blank"
          >
            View on Google
          </a>
        </div>
      </div>
    </div>
  );
};

export default BranchReviews;
